import firebase from 'firebase/app';
import LogManager from '../LogManager';

import 'firebase/analytics';

export default class FirebaseManager {
  static instance = null;

  static getInstance(firebaseConfig) {
    if (!this.instance) {
      this.instance = new FirebaseManager(firebaseConfig);
    }
    return this.instance;
  }

  constructor(firebaseConfig) {
    if (!firebase.apps.length) {
      let FCM_API_KEY = 'AIzaSyCZnFc7Ea4BLfGTa044z3oYkuSD5UF2KuE',
        FCM_AUTH_DOMAIN = 'api-project-317780763450.firebaseapp.com',
        FCM_DATABASE_URL = 'https://api-project-317780763450.firebaseio.com',
        FCM_PROJECT_ID = 'api-project-317780763450',
        FCM_STORAGE_BUCKET = 'api-project-317780763450.appspot.com',
        FCM_MESSAGING_SENDER_ID = '317780763450',
        FCM_APP_ID = '1:317780763450:web:be60c3cf7662af679e6603',
        FCM_MESUREMENT_ID = 'G-XWYHJRQYMY';
      if (firebaseConfig && typeof firebaseConfig === 'object') {
        ({
          FCM_API_KEY = 'AIzaSyCZnFc7Ea4BLfGTa044z3oYkuSD5UF2KuE',
          FCM_AUTH_DOMAIN = 'api-project-317780763450.firebaseapp.com',
          FCM_DATABASE_URL = 'https://api-project-317780763450.firebaseio.com',
          FCM_PROJECT_ID = 'api-project-317780763450',
          FCM_STORAGE_BUCKET = 'api-project-317780763450.appspot.com',
          FCM_MESSAGING_SENDER_ID = '317780763450',
          FCM_APP_ID = '1:317780763450:web:be60c3cf7662af679e6603',
          FCM_MESUREMENT_ID = 'G-XWYHJRQYMY',
        } = firebaseConfig);
      }
      firebase.initializeApp({
        apiKey: FCM_API_KEY,
        authDomain: FCM_AUTH_DOMAIN,
        databaseURL: FCM_DATABASE_URL,
        projectId: FCM_PROJECT_ID,
        storageBucket: FCM_STORAGE_BUCKET,
        messagingSenderId: FCM_MESSAGING_SENDER_ID,
        appId: FCM_APP_ID,
        measurementId: FCM_MESUREMENT_ID,
      });

      const rawLogfunction = firebase.analytics().logEvent;
      firebase.analytics().logEvent = function () {
        const logManager = LogManager.getInstance();

        arguments[1] = processFirebaseEventParams(arguments[1]);
        logManager.log(`[FirebaseEvent] ${arguments[0]}:`, arguments[1]);
        rawLogfunction(...arguments);
      };
    }

    return firebase;
  }
}

function processFirebaseEventParams (params) {
  for (const key in params) {
    const value = params[key]
    if (value || value === 0) {
      const number = Number(value)
      if (!isNaN(number)) {
        params[key] = `_${value}`
      }
    }
  }
  return params
}